/**
 * Global Product Badges Script
 * Fetches collection badge names from https://badges.wearesott.com/badges_api.php
 * Targets any element with [data-badge-product-id] and [data-badge-collection-ids] attributes.
 * Populates matching .bdname_<productId> elements with the badge link.
 */

const BADGES_API_URL = 'https://badges.wearesott.com/badges_api.php';

// Track already-fetched product IDs to avoid duplicate API calls
const _fetchedBadgeIds = new Set();

function fetchAndRenderBadge(/** @type {string} */ productId, /** @type {string} */ collectionIds) {
  if (!productId || _fetchedBadgeIds.has(productId)) return;
  _fetchedBadgeIds.add(productId);

  var collectionElement = /** @type {HTMLInputElement|null} */ (document.getElementById('custom_collection_id'));
  var collection_id = (collectionElement && collectionElement.value) ? collectionElement.value : 'home';

  var url = BADGES_API_URL
    + '?id=' + encodeURIComponent(collectionIds || productId)
    + '&collection_id=' + encodeURIComponent(collection_id);

  fetch(url)
    .then(function(response) {
      if (!response.ok) throw new Error('Badge API HTTP error: ' + response.status);
      return response.json();
    })
    .then(function(res) {
      var collection_title = res.title || '';
      var collection_handle = res.link;
      if (!collection_handle) return;

      var css_class = collection_title === '' ? 'defualt_template_style' : 'not_defualt_template_style';
      var html = '<a class="' + css_class + ' block bg-s-beige h-full text-2xs flex flex-col px-4 h-6 items-center justify-center font-medium tracking-widest uppercase transition-opacity duration-300 hover:opacity-50" href="' + collection_handle + '"><span>' + collection_title + '</span></a>';

      document.querySelectorAll('.bdname_' + productId).forEach(function(el) {
        el.innerHTML = html;
      });
    })
    .catch(function(error) {
      console.warn('Badge API error for product ' + productId + ':', error);
    });
}

function initProductBadges() {
  document.querySelectorAll('[data-badge-product-id]').forEach(function(el) {
    var productId = el.getAttribute('data-badge-product-id') || '';
    var collectionIds = el.getAttribute('data-badge-collection-ids') || '';
    fetchAndRenderBadge(productId, collectionIds);
  });
}

// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductBadges);
} else {
  initProductBadges();
}

// Re-run when new product cards are injected (AJAX, infinite scroll, quick-add, etc.)
/** @type {ReturnType<typeof setTimeout>|undefined} */
var _badgeObserverTimer;
var badgeObserver = new MutationObserver(function() {
  clearTimeout(_badgeObserverTimer);
  _badgeObserverTimer = setTimeout(initProductBadges, 200);
});

badgeObserver.observe(document.body, { childList: true, subtree: true });
